module.exports = __webpack_public_path__ + "img/author.ab77c2c4.jpg";